import { t } from "ttag";

import { type constants } from "@reactivated";

import { ValueOf } from "./types";

type EventTypes = ValueOf<(typeof constants)["server.cms.types.EventType"]>;

export const formatEventType = (v: string) => {
    switch (v as EventTypes) {
        case "inperson":
            return t`In Person`;
        case "virtual":
            return t`Virtual`;
        case "replay":
            return t`Replay`;
        case "ondemand":
            return t`On Demand`;
        default:
            return "";
    }
};

export function getTZShortname(date?: Date) {
    const intlFormat = new Intl.DateTimeFormat(undefined, {
        timeZoneName: "short",
    });
    const parts = intlFormat.formatToParts(date || new Date());
    return parts.find((x) => x.type === "timeZoneName")?.value;
}
